import { AxiosError } from 'axios';

/**
 * 汎用エラーページに送る
 * @param spFlg SPフラグ
 */
export function sendToErrorPage(spFlg: boolean = true): void {
  window.location.href = spFlg ? '/smp2/error/500/' : '/net2/error/500/';
}

/**
 * セッション切れページに送る
 * @param spFlg SPフラグ
 */
export function sendToSessionExpirePage(spFlg: boolean = true): void {
  window.location.href = spFlg ? '/smp2/error/timeout/session/' : '/net2/error/timeout/session/';
}

/**
 * 閉塞エラーページに送る
 * @param spFlg SPフラグ
 */
export function sendToMaintenancePage(spFlg: boolean = true): void {
  window.location.href = spFlg ? '/smp2/error/shinroAccountApiMainte/' : '/net2/error/shinroAccountApiMainte/';
}

/**
 * エラー種別
 */
export const ERROR_TYPES = {
  SYSTEM_ERROR: 'system error',
  SESSION_EXPIRE: 'session expire',
  OTHER: 'other expire',
} as const;

type ErrorType = typeof ERROR_TYPES[keyof typeof ERROR_TYPES];

/**
 * レスポンスエラー種別を判定する
 * @param error エラーをそのまま詰め込む
 * @returns エラー種別
 */
export function judgeResponseErrorType(error: AxiosError): ErrorType {
  if (error.response === undefined) return ERROR_TYPES.OTHER;
  if (error.response.status === 500) {
    const errorMessage = error.response.data.split('\n');
    // 上の方にエラーいれてもらってるので3行目までのみチェック
    for (let index = 0; index < 4; index += 1) {
      if (errorMessage[index].indexOf('expiredSession') !== -1) {
        return ERROR_TYPES.SESSION_EXPIRE;
      }
      if (errorMessage[index].indexOf('systemError') !== -1) {
        return ERROR_TYPES.SYSTEM_ERROR;
      }
    }
  }
  return ERROR_TYPES.OTHER;
}

/**
 * 汎用エラー分岐
 */
export function judgeErrorAndSendToErrorPage(error: AxiosError, isSpFlg: boolean): void {
  const judgedErrorType = judgeResponseErrorType(error);
  if (judgedErrorType === ERROR_TYPES.OTHER || judgedErrorType === ERROR_TYPES.SYSTEM_ERROR) {
    sendToErrorPage(isSpFlg);
  } else {
    sendToSessionExpirePage(isSpFlg);
  }
}
